// extracted by mini-css-extract-plugin
module.exports = {"overAll":"messages_overAll__2uYE9","messageContainer":"messages_messageContainer__2rFcz"};